// Match the server's 100-key cap and no-overlapping-contact rule.
// Review-only and blocked suggestions must always be selected individually.
export const selectAllReadyContactRepairKeys = (proposals = [], max = 100) => {
  const selected = [];
  const usedIds = new Set();
  for (const pair of proposals) {
    if (!pair?.safe || pair.confidence !== "strong" ||
        !pair.key || !pair.keepId || !pair.removeId ||
        pair.keepId === pair.removeId ||
        usedIds.has(pair.keepId) || usedIds.has(pair.removeId)) continue;
    selected.push(pair.key);
    usedIds.add(pair.keepId);
    usedIds.add(pair.removeId);
    if (selected.length === max) break;
  }
  return selected;
};
